import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AlertService } from '../services/alert.service';
import { ToastrService } from 'ngx-toastr';
import{environment} from '../../environments/environment'

@Component({
  selector: 'app-consumer-change-password',
  templateUrl: './consumer-change-password.component.html',
  styleUrls: ['./consumer-change-password.component.css']
})
export class ConsumerChangePasswordComponent implements OnInit {

  constructor(private route: ActivatedRoute, private authService: AuthService, private alertService: AlertService, private toastService: ToastrService) { }
  @ViewChild("changePasswordForm") form: NgForm;
  token: string;
  id: string;
  passwordPolicy: any;
  passwordError: any = { isError: false, errorMessage: '' };
  model: any;
  isToken:boolean=false;
  logoutUrl:any;
  responseError:boolean=false;
  responseErrorText:any;
  ngOnInit() {
    document.getElementsByTagName('body')[0].className = "gray-bg";
    document.getElementById('page-wrapper').className = "gray-bg";
    this.model = { current: '', newPassword: '', confirmPassword: '' };
    this.token = this.route.snapshot.queryParams["token"];
    this.logoutUrl=environment.serverUrl+"exgsfsso/logoutAll?returnURL="+ this.route.snapshot.queryParams["logouturl"]+"&state="+this.route.snapshot.queryParams["state"];
    this.authService.getTokenDetails(this.token).subscribe((result: any) => {
      if (!result.success) {
        this.toastService.error("Your session is expired.Please login again");
        this.isToken=true;
      } else {
        debugger;
      this.id =  result["data"]["userData"]["user_id"];
        this.passwordPolicy = result["data"]["passwordPolicy"];
        document.getElementsByTagName('nav')[0].style.display = "none";
        document.getElementsByTagName('nav')[1].style.display = "none";
        document.getElementsByClassName('theme-config')[0].className = 'hide';
      }
    })
  }
  onSubmit(form: NgForm) {
    if(this.isToken){
      this.toastService.error("Your session is expired.Please login again");
      return;
    }
    if (form.valid && !this.validatePassword()) {
      this.authService.changePasswordGSF(this.id, this.form.value).subscribe((res: any) => {
        if (res.error)
         {
           // this.toastService.error(res.message);
            this.responseError=true;
            this.responseErrorText=res.message;
          }
        else {
          this.toastService.success(res.message);
          form.resetForm();
          window.location.href=  this.logoutUrl;
          this.responseError=false;
        }
      }, error => {
        this.toastService.error(error.error, 'Validation');
      });
    } else {

    }
  }
  validatePassword() {
    this.responseError=false;
    if (this.passwordPolicy && this.passwordPolicy.regexValidators != undefined) {
      for (var i = 0; i < this.passwordPolicy.regexValidators.length; i++) {
        if (!this.form.controls.newPassword.value.match(this.passwordPolicy.regexValidators[i].value)) {
          this.passwordError.isError = true;
          this.passwordError.errorMessage = this.passwordPolicy.regexValidators[i].text;
          break;
        } else {
          this.passwordError.isError = false;
        }
      }
    }
    if(!this.passwordError.isError){
      if(this.form.controls.newPassword.value.startsWith(" ") || this.form.controls.newPassword.value.endsWith(" ")){
        this.passwordError.isError = true;
        this.passwordError.errorMessage="Password can't start or end with spaces";
      }
    }
    if (this.passwordPolicy && this.passwordPolicy.enforceCustumList != undefined && this.passwordPolicy.enforceCustumList) {
      var blacklist = this.passwordPolicy.customBannedList[0].split('\n');
      if (blacklist.some(item => item == this.form.controls.newPassword)) {
        this.passwordError.errorMessage = "This Password is in blacklist";
        this.passwordError.isError = true;
      }
    }
    return this.passwordError.isError;
  }
  back() {
    window.history.back();
  }
}
